import React from 'react';

import classNames from '@utils/classnames';

export interface ITotalsCardRow {
  label: React.ReactNode;
  value: React.ReactNode;
  /** The grand total — both label and value go bold. */
  isEmphasised?: boolean;
}

export interface ITotalsCardProps {
  rows: ITotalsCardRow[];
  className?: string;
}

/** Right-aligned totals block that closes off a financial detail page. */
export const TotalsCard: React.FC<ITotalsCardProps> = ({ rows, className }) => {
  return (
    <div className="flex justify-end">
      <div className={classNames('card w-80 px-5 py-3.5', className)}>
        <div className="flex flex-col gap-1.5">
          {rows.map((row, index) => (
            <div className="flex items-center gap-3" key={index}>
              <div
                className={classNames(
                  'min-w-0 flex-1 text-xs',
                  row.isEmphasised ? 'font-semibold text-fg' : 'text-fg-secondary',
                )}
              >
                {row.label}
              </div>
              <div
                className={classNames(
                  'whitespace-nowrap text-sm text-fg',
                  row.isEmphasised ? 'font-semibold' : 'font-medium',
                )}
              >
                {row.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
